// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> axia-residential-arc-living-preferred -> the-preston
// Generated: 2026-10-01T17:22:54.797Z
// Counts: 5 design, 85 content, 28 slot group, 6 collection binding, 9 section, 3 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "VALUE",
    "value": "#00306b",
    "mappedField": null
  },
  "design._site.color.linkHover": {
    "cssVariable": "--vibe-color-link-hover",
    "overrideType": "VALUE",
    "value": "#00306b",
    "mappedField": null
  },
  "design._site.color.linkVisited": {
    "cssVariable": "--vibe-color-link-visited",
    "overrideType": "VALUE",
    "value": "#00306b",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Open living spaces and everyday comfort.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Beautifully renovated <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments homes in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 40px;\">More Space. More Comfort. More to Love.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Nestled near top schools like Oakland Elementary and Eagle's Landing High, our community is your gateway to enriching experiences. See what's around and uncover local favorites!</p><ul><li><p><strong>3 minutes to Historic Downtown McDonough</strong></p></li><li><p><strong>5 minutes to shopping &amp; dining</strong></p></li><li><p><strong>Easy access to I-75</strong></p></li><li><p><strong>Nearby parks &amp; recreation</strong></p></li><li><p><strong>Henry County Schools</strong></p></li><li><p><strong>Convenient to Atlanta employers</strong></p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "Explore Apartment Living in McDonough, GA",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Room to Live. Space to Grow.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to The Preston</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.heading": {
    "overrideType": "VALUE",
    "customValue": " ",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.intro": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-map.config_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_repli_id"
  },
  "applynowactions.show_application_block": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "callrail-tracking.account_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_account_hash"
  },
  "callrail-tracking.company_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_company_id"
  },
  "contactus.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height_mobile": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.height": {
    "overrideType": "VALUE",
    "customValue": "2000",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "preferredemployerprogram.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Exclusive Apartment Offers for Employees in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.source": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.scheduler_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "scheduleatour.show_tour_scheduler": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.height": {
    "overrideType": "VALUE",
    "customValue": "1400",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019df43d-7815-7526-9d44-2ede7fd3f2d8.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 28px;\"><strong>Everyday Living Made Better</strong></span></h2><p>At The Preston, every amenity is designed to make life a little easier—from morning workouts and relaxing afternoons by the pool to evenings spent grilling with friends.</p><p>Enjoy movie nights at our theatre room or challenge friends to a match on the volleyball or tennis courts. Great amenities are also prioritized, featuring a gated entrance, courtesy patrol, valet trash program, and garage parking options.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 28px;\"><strong>We'd Love to Show You Around</strong></span></h2><p>Whether you're ready to tour or simply have a few questions, our friendly leasing team is here to help you find the apartment that feels like home.</p><p>Schedule a tour today—we can't wait to welcome you to The Preston.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find a Floor Plan That Fits Your Life</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card2.description": {
    "overrideType": "VALUE",
    "customValue": "<p>See what life at The Preston is all about.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card2.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Imagine Your Everyday Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Preston in McDonough, GA, our thoughtfully designed floor plans cater to every lifestyle, whether you seek a cozy one-bedroom retreat or a spacious three-bedroom haven. Browse our available apartment homes and elevate your living experience in a vibrant community that truly feels like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Experience the lifestyle you've always dreamed of at The Preston. With unique features like wood-style flooring, comfortable carpeted bedrooms, and private balconies or patios, your new apartment is waiting to welcome you home.</span></p><p>Select your desired layout below.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 28px;\"><strong>Picture Your Next Chapter</strong></span></h2><p>Browse our gallery and imagine relaxing poolside, entertaining friends, or coming home to a beautifully renovated apartment designed for everyday comfort. Explore <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one, two, or three-bedroom floor plans</a> featuring upgraded amenities.</p><p>Picture yourself enjoying resort-style living with our state-of-the-art fitness center, inviting swimming pool, and community kitchen—your dream lifestyle awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 28px;\"><strong>Love Where You Live</strong></span></h2><p>Living at The Preston means enjoying the best of McDonough.</p><p>Spend weekends exploring Historic Downtown McDonough, discover local restaurants and shopping, enjoy nearby parks, and commute with ease thanks to quick access to I-75.</p><p>Whether you're heading to work, grabbing dinner with friends, or spending the afternoon outdoors, everything you need is just minutes away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 28px;\"><strong>We Love Pets</strong></span></p><p>At The Preston, we warmly welcome your pets, recognizing that they're essential members of your family. Our pet-friendly apartment community comfortably accommodates up to two pets per apartment, providing ample space and surroundings they’ll love. If you have any specific questions or require further details about our pet amenities and restrictions, our dedicated team is always here to assist you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p>Breed restrictions apply, maximum 2 pets per apartment, up to 75 lb each</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerprogram.employers_list": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>First responders</p></li><li><p>Educators</p></li><li><p>Military</p></li><li><p>Law enforcement</p></li><li><p>Delta Airlines</p></li><li><p>Piedmont Healthcare</p></li><li><p>Henry County</p></li><li><p>City of McDonough</p></li><li><p>Alpla</p></li><li><p>Nestle</p></li><li><p>Amazon</p></li><li><p>Home Depot</p></li><li><p>NewCold</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Life looks a little different for everyone, and your home should be able to keep up. Whether you're working remotely, raising a family, or simply looking for more room to relax, The Preston offers spacious apartment homes designed for everyday living.</p><p>Inside your home, you'll enjoy renovated interiors, stainless steel appliances, upgraded finishes, in-home washers and dryers, fireplaces in select homes, and private outdoor spaces.</p><p>Outside your front door, unwind by one of two resort-style pools, stay active in the fitness center, gather with friends around the grilling stations, or spend weekends enjoying everything McDonough has to offer.</p><p>At The Preston, you're not just finding an apartment—you're finding a place to truly feel at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 24px;\"><strong>Explore Our Community &amp; Apartment Homes</strong></span></p><p>Experience our vibrant community firsthand by taking a virtual tour today and envision your new home at The Preston!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_online_leasing_url"
      }
    }
  },
  "_template:hyperlocal::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "featuring/apartment-with-pool-monroe-30655::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019f5d0e-8508-74e7-9452-921160c8bcb4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "People enjoying a large outdoor swimming pool with lounge chairs and apartment buildings in the background."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-34cb-77f9-8a4a-af410eca2300.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings with balconies and manicured lawns."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": 26,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019df6bc-cbf2-749b-82a5-17cede2e4fa7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a queen-size bed, nightstand, clock, and walk-in closet."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": 66,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019f5d0e-8508-74e7-9452-921160c8bcb4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "People enjoying a large outdoor swimming pool with lounge chairs and apartment buildings in the background."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-7e48-75fa-ba76-3e368f3feb06.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Person walking a poodle in a park during autumn."
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5504-5ca6-70fd-83bc-690168bcdc3c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, nightstand, closet, and dresser."
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019e3ed3-730f-701e-8da7-cf0830bf143f.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019df6bc-cbf2-749b-82a5-17cede2e4fa7.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-a5f5-727a-8b69-2733d2f0a379.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019e3ed3-a6e4-73dc-a564-919a3ae22fd2.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019df6bc-b7e8-748a-8ae6-2cd87cbc3589.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Swimming pool and lounge area with building in the background."
      }
    }
  },
  "hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore Available Homes",
        "mappedField": ""
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans",
        "mappedField": ""
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "interactivemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-fabf-70a7-8ba0-48a0eac111fb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops."
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[27].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[27].poi_featured_image_media.alt_text"
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": 116,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019f4d1f-8789-70c2-8c08-a34d640c0ece.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with treadmills, elliptical, weight machines, and free weights."
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[0].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[0].poi_featured_image_media.alt_text"
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019fa606-f1cf-7260-8e03-f55c202f475f.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Happy group of friends enjoying a rooftop party with drinks, laughter, and dancing at sunset."
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019fa601-ef4b-724a-9be5-cdac5bb0b365.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A Bengal cat and Yorkshire Terrier playfully reach for a feathered toy indoors."
      }
    }
  },
  "preferredemployerhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019ff288-c448-746e-a0ce-768ed58530d5.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Diverse team of call center agents working at computers in an office setting, focused on tasks."
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your Perfect Floor Plan"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans",
        "mappedField": ""
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019e3ed3-7365-72af-9026-3e95160d53f5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room and kitchen area with blue sofa, yellow chairs, and bar stools."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": 7,
    "hiddenIds": [
      "custom_774f16a1-d0c4-4cea-80a7-206a4be73219",
      "custom_a03c871a-6696-46ef-acf3-497a49c299ca",
      "custom_7bcb096f-5210-4ed8-af3c-057c0f502cc0",
      "custom_7d8c4547-fc66-4a33-beca-5ca6db706355",
      "custom_bf538a5e-d8cf-4f92-9a71-6d51b3cdba32",
      "custom_7c762b63-38f5-4c98-a2ad-18aa2f287131",
      "custom_cec2af1a-f5a1-4f7b-8e7e-6e4047c88c97",
      "custom_d41ea2d6-9167-4f4d-ae5a-971e4fad852b",
      "custom_da75ae28-faec-4097-ba5c-a1fbd088157f",
      "custom_5893619e-a638-4f96-9670-bf81c4787725",
      "custom_3cf20850-8fb2-4166-8a7c-0ef3cfe71515",
      "custom_8c9e62bd-f442-42b1-b599-e3e6188f4557",
      "custom_25a41473-5dff-4bf4-a10d-155379577312",
      "custom_215a7823-13b1-4d07-ae45-e1ea14b9771e",
      "custom_0d1a388d-9fdf-403a-a5b2-981089f365e8",
      "custom_b18cc7eb-59d0-4e7f-84f5-0f9ab02679fa",
      "custom_012e16b0-f4b1-45b6-a31c-bcaeb165dff7",
      "custom_073915b4-08c2-4893-9779-8996cad7cd7a"
    ],
    "orderedIds": [
      "custom_f8d69417-aa96-4a45-a1f2-8813ea0a4ca0",
      "custom_0d1c9c0f-8e5c-4dc5-9af1-0c10130db760",
      "custom_216594e1-03e7-4dce-af2d-fa0de35745f3",
      "custom_8671d63b-d294-4be4-8033-84a52bdadbd4",
      "custom_870d3b16-f792-4b8c-ad86-49024efa5e35",
      "custom_2eb4f31f-214f-4b53-aa54-9371fe2a57cc",
      "custom_b18cc7eb-59d0-4e7f-84f5-0f9ab02679fa",
      "custom_012e16b0-f4b1-45b6-a31c-bcaeb165dff7",
      "custom_073915b4-08c2-4893-9779-8996cad7cd7a",
      "custom_70c3de02-b7b9-498a-a0e5-5a68cf7004e4",
      "custom_7bcb096f-5210-4ed8-af3c-057c0f502cc0",
      "custom_7d8c4547-fc66-4a33-beca-5ca6db706355",
      "custom_774f16a1-d0c4-4cea-80a7-206a4be73219",
      "custom_a03c871a-6696-46ef-acf3-497a49c299ca",
      "custom_dc09515d-da8d-48ed-b680-9bafae86997a",
      "custom_fa752639-3822-41ef-89d7-edd6bc3b9cee",
      "custom_60a433f6-0a7a-4870-868c-b4dcf9234569",
      "custom_bf538a5e-d8cf-4f92-9a71-6d51b3cdba32",
      "custom_7c762b63-38f5-4c98-a2ad-18aa2f287131",
      "custom_cec2af1a-f5a1-4f7b-8e7e-6e4047c88c97",
      "custom_d41ea2d6-9167-4f4d-ae5a-971e4fad852b",
      "custom_da75ae28-faec-4097-ba5c-a1fbd088157f",
      "custom_5893619e-a638-4f96-9670-bf81c4787725",
      "custom_3286a4b9-4449-4fa0-bb42-fa10c5b8b224",
      "custom_10e9676b-e80f-4f5c-82f9-de84e10eb9eb",
      "custom_3cf20850-8fb2-4166-8a7c-0ef3cfe71515",
      "custom_51228da7-ecc3-49ab-9e7c-3ab6fcfd56f0",
      "custom_f8aec528-35ef-4bc4-92ec-2ba86f530e65",
      "custom_8c9e62bd-f442-42b1-b599-e3e6188f4557",
      "custom_25a41473-5dff-4bf4-a10d-155379577312",
      "custom_215a7823-13b1-4d07-ae45-e1ea14b9771e",
      "custom_0d1a388d-9fdf-403a-a5b2-981089f365e8",
      "custom_5edcd6bf-2e2c-4300-bc9e-6169b157aaf9",
      "custom_a885febf-891f-4943-a279-7a0ecc661313",
      "custom_449a881a-5dd4-410e-8758-7e63c1e35606",
      "custom_1cb0d3d7-52d0-4e94-8c0f-c9981a6b6ed0",
      "custom_600c4088-3afe-4694-b981-41e36e7b7f50",
      "custom_6c529cf2-d601-4163-a074-fe11e628bcda",
      "custom_7298cfa7-cb27-4d39-868a-5a44d0a9dafd",
      "custom_51eba66c-cbe4-4c92-a610-b0afd0ca86d8",
      "custom_14282197-8a02-406b-8627-dfe4e46eeda0",
      "custom_9ccd933e-047f-4e8f-9226-a85b5c16e8a2",
      "custom_16f4f095-912c-484b-ab39-8a5d7ddaa9e3",
      "custom_db540e51-08c9-4dbb-85b9-67e4e3aa13bb",
      "custom_57a46528-281b-4336-a156-7ce6cf5b3705",
      "custom_0ac6f99e-f73e-464a-a57b-a978728baea3",
      "custom_524d12a7-ae80-4c7c-8d51-4a3e8dc4c64d",
      "custom_2232c1d8-84db-494c-8112-c1db54686e7c",
      "custom_fdea397d-7530-4f7c-935c-fe2e2d009baf",
      "custom_a6cbe333-6c93-4f93-bb1c-76a4e8e0cd67",
      "custom_fcb78d4a-3044-4d2f-956a-4d043d78813d",
      "custom_eac708ff-06c4-46cb-b43c-573f2e2b2fcd",
      "custom_6d8378e4-7e08-44c9-a168-4c3539e36a88",
      "custom_2aea9ff4-f0fc-47a8-9909-317549012f5a",
      "custom_ce2ab245-426b-40a3-beb3-91ee0352e184",
      "custom_9355359b-1af5-405c-aab6-64cb9fd87909",
      "custom_a9f21928-25e9-457f-b4eb-b48af142f428",
      "custom_2b74bccc-c6bc-4ff1-a3cd-ffdfbb70892f",
      "custom_2e1a8b47-33e2-4fd4-b618-a1ef1d53460b",
      "custom_68889ba5-afe4-4010-84a7-7d2625975276",
      "custom_bd968bdf-72e2-46fc-a3bc-c94e82a6f8cf",
      "custom_31ad83ac-8ea2-438f-839b-42e319e57647"
    ],
    "hiddenIndices": [
      4,
      6,
      2,
      3,
      11,
      13,
      14,
      16,
      17,
      18,
      21,
      24,
      25,
      27,
      28,
      0,
      5,
      1
    ],
    "ordering": [
      15,
      12,
      52,
      42,
      26,
      29,
      0,
      5,
      1,
      9,
      2,
      3,
      4,
      6,
      7,
      10,
      8,
      11,
      13,
      14,
      16,
      17,
      18,
      20,
      19,
      21,
      22,
      23,
      24,
      25,
      27,
      28,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_870d3b16-f792-4b8c-ad86-49024efa5e35",
      "custom_8671d63b-d294-4be4-8033-84a52bdadbd4",
      "custom_7298cfa7-cb27-4d39-868a-5a44d0a9dafd",
      "custom_2eb4f31f-214f-4b53-aa54-9371fe2a57cc",
      "custom_21ce6044-7a7c-41a8-b7a0-9508001c9e5f",
      "custom_9ccd933e-047f-4e8f-9226-a85b5c16e8a2",
      "custom_10e9676b-e80f-4f5c-82f9-de84e10eb9eb",
      "custom_51228da7-ecc3-49ab-9e7c-3ab6fcfd56f0",
      "custom_f8aec528-35ef-4bc4-92ec-2ba86f530e65",
      "custom_25a41473-5dff-4bf4-a10d-155379577312",
      "custom_fcb78d4a-3044-4d2f-956a-4d043d78813d",
      "custom_60a433f6-0a7a-4870-868c-b4dcf9234569",
      "custom_449a881a-5dd4-410e-8758-7e63c1e35606",
      "custom_215a7823-13b1-4d07-ae45-e1ea14b9771e",
      "custom_fa752639-3822-41ef-89d7-edd6bc3b9cee",
      "custom_5edcd6bf-2e2c-4300-bc9e-6169b157aaf9",
      "custom_a885febf-891f-4943-a279-7a0ecc661313",
      "custom_1cb0d3d7-52d0-4e94-8c0f-c9981a6b6ed0",
      "custom_600c4088-3afe-4694-b981-41e36e7b7f50",
      "custom_6c529cf2-d601-4163-a074-fe11e628bcda",
      "custom_51eba66c-cbe4-4c92-a610-b0afd0ca86d8",
      "custom_14282197-8a02-406b-8627-dfe4e46eeda0",
      "custom_16f4f095-912c-484b-ab39-8a5d7ddaa9e3",
      "custom_db540e51-08c9-4dbb-85b9-67e4e3aa13bb",
      "custom_57a46528-281b-4336-a156-7ce6cf5b3705",
      "custom_0ac6f99e-f73e-464a-a57b-a978728baea3",
      "custom_524d12a7-ae80-4c7c-8d51-4a3e8dc4c64d",
      "custom_2232c1d8-84db-494c-8112-c1db54686e7c",
      "custom_fdea397d-7530-4f7c-935c-fe2e2d009baf",
      "custom_a6cbe333-6c93-4f93-bb1c-76a4e8e0cd67",
      "custom_6d8378e4-7e08-44c9-a168-4c3539e36a88",
      "custom_a9f21928-25e9-457f-b4eb-b48af142f428",
      "custom_2e1a8b47-33e2-4fd4-b618-a1ef1d53460b",
      "custom_15213f11-f706-4a79-9478-d67b530690c1",
      "custom_93ccf5bb-433b-4264-aaa9-80def1f17a99",
      "custom_94155b7c-f648-4ebe-842e-d43114ce4a4b",
      "custom_a7146f85-55e6-43c8-a126-d82410ca0e02",
      "custom_de6717d5-2f17-4501-a00e-901ec8989b05",
      "custom_9fbb8626-c811-4032-9b15-3f18aa09c83d",
      "custom_5ac70284-430f-4909-bf53-0c91a7214969",
      "custom_e128200c-47a2-471c-954a-66185b6cb4dd",
      "custom_e0ca08a0-6bd7-41fd-81b0-03a29a4d2e7b",
      "custom_d3165e95-8afd-43a2-97db-b0bf094a10af",
      "custom_fdca9f81-a929-42c4-823d-48dcff4abc75",
      "custom_a0fa0716-6a1f-4203-9f43-3737866ef548",
      "custom_1eccd9a7-a173-4c43-9983-40d07f4fe333",
      "custom_966bcea6-0c60-418b-adde-564f74fc9a8a",
      "custom_b684d900-3aec-433c-92cd-1b3971ff8646",
      "custom_0d8b3557-0a2c-419f-9646-d9106a646879",
      "custom_5aa01b6c-4a24-42f0-a106-5f47030fff0f",
      "custom_03996cd7-80cd-47b9-82a5-b8fee05f3530",
      "custom_1e7ac4f2-471e-46ce-bd7d-d14835394135",
      "custom_ba6b9016-fd5a-4e78-bcc1-4731fddf15b2",
      "custom_aa1a64f2-08fc-42be-8de6-8afd630f371b",
      "custom_5ef3dd86-5ecf-4cf8-b200-eff36a21a391",
      "custom_5f18451f-8a40-4076-a722-e5c9c2326edf",
      "custom_f9e4f50a-80a9-4f6f-a7c3-3dce85c24174",
      "custom_4ebe5d75-1164-4405-b0c1-b78d379fdc3d"
    ],
    "hiddenIndices": null,
    "ordering": [
      6,
      21,
      15,
      8,
      36,
      18,
      2,
      3,
      4,
      5,
      28,
      0,
      11,
      7,
      1,
      9,
      10,
      12,
      13,
      14,
      16,
      17,
      19,
      20,
      22,
      23,
      24,
      25,
      26,
      27,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57
    ],
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": 9,
    "hiddenIds": [
      "custom_073915b4-08c2-4893-9779-8996cad7cd7a",
      "custom_7bcb096f-5210-4ed8-af3c-057c0f502cc0"
    ],
    "orderedIds": [
      "custom_de8f3566-a852-4c1f-8915-501a96ec3b57",
      "custom_a6024253-79e9-4c0e-ba15-ae5a7476b348",
      "custom_b18cc7eb-59d0-4e7f-84f5-0f9ab02679fa",
      "custom_7d8c4547-fc66-4a33-beca-5ca6db706355",
      "custom_774f16a1-d0c4-4cea-80a7-206a4be73219",
      "custom_0d1c9c0f-8e5c-4dc5-9af1-0c10130db760",
      "custom_012e16b0-f4b1-45b6-a31c-bcaeb165dff7",
      "custom_70c3de02-b7b9-498a-a0e5-5a68cf7004e4",
      "custom_7bcb096f-5210-4ed8-af3c-057c0f502cc0",
      "custom_073915b4-08c2-4893-9779-8996cad7cd7a",
      "custom_dc09515d-da8d-48ed-b680-9bafae86997a",
      "custom_a03c871a-6696-46ef-acf3-497a49c299ca",
      "custom_bf538a5e-d8cf-4f92-9a71-6d51b3cdba32",
      "custom_7c762b63-38f5-4c98-a2ad-18aa2f287131",
      "custom_cec2af1a-f5a1-4f7b-8e7e-6e4047c88c97",
      "custom_f8d69417-aa96-4a45-a1f2-8813ea0a4ca0",
      "custom_d41ea2d6-9167-4f4d-ae5a-971e4fad852b",
      "custom_da75ae28-faec-4097-ba5c-a1fbd088157f",
      "custom_5893619e-a638-4f96-9670-bf81c4787725",
      "custom_3286a4b9-4449-4fa0-bb42-fa10c5b8b224",
      "custom_3cf20850-8fb2-4166-8a7c-0ef3cfe71515",
      "custom_8c9e62bd-f442-42b1-b599-e3e6188f4557",
      "custom_0d1a388d-9fdf-403a-a5b2-981089f365e8",
      "custom_eac708ff-06c4-46cb-b43c-573f2e2b2fcd",
      "custom_216594e1-03e7-4dce-af2d-fa0de35745f3",
      "custom_2aea9ff4-f0fc-47a8-9909-317549012f5a",
      "custom_ce2ab245-426b-40a3-beb3-91ee0352e184",
      "custom_9355359b-1af5-405c-aab6-64cb9fd87909",
      "custom_2b74bccc-c6bc-4ff1-a3cd-ffdfbb70892f",
      "custom_68889ba5-afe4-4010-84a7-7d2625975276",
      "custom_bd968bdf-72e2-46fc-a3bc-c94e82a6f8cf",
      "custom_31ad83ac-8ea2-438f-839b-42e319e57647",
      "custom_a05491ca-37e6-431d-878f-29277890f150",
      "custom_fd6c628e-a141-422f-b290-b87948894a8b",
      "custom_1f7eb865-9af3-4318-9427-8c496220ef65",
      "custom_c8536267-5a38-46df-9b16-b5aa87a2d69b",
      "custom_5f1323fa-bb9f-4cce-8b5e-a390df5193f3",
      "custom_9087fe08-b3bb-4e83-840f-acea58ad99d8",
      "custom_b28eabe2-54d1-4ac8-9627-6cc5630983b4",
      "custom_2fe0976f-bc79-4ed6-80f4-24e068e9d285",
      "custom_4f396ac2-5fd4-4e3a-8ff3-60652dcec6d3",
      "custom_d1c904c4-04ff-443d-a61d-af1fba337bc0",
      "custom_b4a20275-dfa0-4bf7-97c5-2f77d44754df",
      "custom_3cdcca2d-5820-4836-9adf-30c1394bc2e0",
      "custom_1bb106d8-a7ae-4871-b714-5975a322ce32",
      "custom_4b07b9b4-cc92-4dd0-adbf-902d6c801bd9",
      "custom_085f86e1-f232-4de2-8e78-3755c3e4f7a2",
      "custom_a6984164-88c7-4560-81f2-5c65a41475f8",
      "custom_4c7a66c8-6775-4ae5-b7e1-c73b7ac1f938",
      "custom_80236db5-e4b8-4a3d-a9c5-0a2983fc03c7",
      "custom_15461f07-cc9f-4061-9309-59281a84fcd3",
      "custom_998a01ed-e058-4e55-a6d4-3db629054e5b",
      "custom_af0de621-2757-4d4d-9d3b-648e63c5caa4",
      "custom_49fda75f-865a-4f66-8444-0b0208fb9f3c",
      "custom_8d5735ea-c4c2-4347-95a9-391f5d63fb0b",
      "custom_6fdf1c1f-4400-4abe-bffe-806c87b2cff0",
      "custom_4969ded5-0bcb-4a5a-ba25-3fbc0c405c7b",
      "custom_b51929c3-5018-46cf-a1a1-edbad60c1e5c",
      "custom_fe91547e-3d50-40bb-aa3c-95bde4d166cc",
      "custom_a8576a42-5ea3-4a4f-a3b4-96846a4e6737",
      "custom_535d1fab-ba80-4f64-a1b3-8be841a7ae8c"
    ],
    "hiddenIndices": [
      1,
      2
    ],
    "ordering": [
      60,
      59,
      0,
      3,
      4,
      10,
      5,
      8,
      2,
      1,
      7,
      6,
      9,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58
    ],
    "customItems": null
  },
  "gallery.images": {
    "limit": 28,
    "hiddenIds": [
      "custom_cec2af1a-f5a1-4f7b-8e7e-6e4047c88c97",
      "custom_b18cc7eb-59d0-4e7f-84f5-0f9ab02679fa",
      "custom_7bcb096f-5210-4ed8-af3c-057c0f502cc0",
      "custom_7d8c4547-fc66-4a33-beca-5ca6db706355",
      "custom_d41ea2d6-9167-4f4d-ae5a-971e4fad852b",
      "custom_da75ae28-faec-4097-ba5c-a1fbd088157f",
      "custom_5893619e-a638-4f96-9670-bf81c4787725",
      "custom_3cf20850-8fb2-4166-8a7c-0ef3cfe71515",
      "custom_8c9e62bd-f442-42b1-b599-e3e6188f4557",
      "custom_25a41473-5dff-4bf4-a10d-155379577312",
      "custom_eac708ff-06c4-46cb-b43c-573f2e2b2fcd",
      "custom_2aea9ff4-f0fc-47a8-9909-317549012f5a",
      "custom_ce2ab245-426b-40a3-beb3-91ee0352e184",
      "custom_9355359b-1af5-405c-aab6-64cb9fd87909",
      "custom_60a433f6-0a7a-4870-868c-b4dcf9234569",
      "custom_a0fa0716-6a1f-4203-9f43-3737866ef548",
      "custom_7c762b63-38f5-4c98-a2ad-18aa2f287131",
      "custom_3286a4b9-4449-4fa0-bb42-fa10c5b8b224",
      "custom_bf538a5e-d8cf-4f92-9a71-6d51b3cdba32",
      "custom_012e16b0-f4b1-45b6-a31c-bcaeb165dff7",
      "custom_073915b4-08c2-4893-9779-8996cad7cd7a",
      "custom_70c3de02-b7b9-498a-a0e5-5a68cf7004e4",
      "custom_dc09515d-da8d-48ed-b680-9bafae86997a",
      "custom_a03c871a-6696-46ef-acf3-497a49c299ca"
    ],
    "orderedIds": [
      "custom_774f16a1-d0c4-4cea-80a7-206a4be73219",
      "custom_f8d69417-aa96-4a45-a1f2-8813ea0a4ca0",
      "custom_7c762b63-38f5-4c98-a2ad-18aa2f287131",
      "custom_3286a4b9-4449-4fa0-bb42-fa10c5b8b224",
      "custom_bf538a5e-d8cf-4f92-9a71-6d51b3cdba32",
      "custom_012e16b0-f4b1-45b6-a31c-bcaeb165dff7",
      "custom_073915b4-08c2-4893-9779-8996cad7cd7a",
      "custom_70c3de02-b7b9-498a-a0e5-5a68cf7004e4",
      "custom_0d1c9c0f-8e5c-4dc5-9af1-0c10130db760",
      "custom_216594e1-03e7-4dce-af2d-fa0de35745f3",
      "custom_dc09515d-da8d-48ed-b680-9bafae86997a",
      "custom_870d3b16-f792-4b8c-ad86-49024efa5e35",
      "custom_8671d63b-d294-4be4-8033-84a52bdadbd4",
      "custom_60a433f6-0a7a-4870-868c-b4dcf9234569",
      "custom_2eb4f31f-214f-4b53-aa54-9371fe2a57cc",
      "custom_fa752639-3822-41ef-89d7-edd6bc3b9cee",
      "custom_1eccd9a7-a173-4c43-9983-40d07f4fe333",
      "custom_2b74bccc-c6bc-4ff1-a3cd-ffdfbb70892f",
      "custom_7bcb096f-5210-4ed8-af3c-057c0f502cc0",
      "custom_7d8c4547-fc66-4a33-beca-5ca6db706355",
      "custom_a03c871a-6696-46ef-acf3-497a49c299ca",
      "custom_b18cc7eb-59d0-4e7f-84f5-0f9ab02679fa",
      "custom_cec2af1a-f5a1-4f7b-8e7e-6e4047c88c97",
      "custom_d41ea2d6-9167-4f4d-ae5a-971e4fad852b",
      "custom_da75ae28-faec-4097-ba5c-a1fbd088157f",
      "custom_5893619e-a638-4f96-9670-bf81c4787725",
      "custom_10e9676b-e80f-4f5c-82f9-de84e10eb9eb",
      "custom_3cf20850-8fb2-4166-8a7c-0ef3cfe71515",
      "custom_51228da7-ecc3-49ab-9e7c-3ab6fcfd56f0",
      "custom_f8aec528-35ef-4bc4-92ec-2ba86f530e65",
      "custom_8c9e62bd-f442-42b1-b599-e3e6188f4557",
      "custom_25a41473-5dff-4bf4-a10d-155379577312",
      "custom_215a7823-13b1-4d07-ae45-e1ea14b9771e",
      "custom_0d1a388d-9fdf-403a-a5b2-981089f365e8",
      "custom_5edcd6bf-2e2c-4300-bc9e-6169b157aaf9",
      "custom_a885febf-891f-4943-a279-7a0ecc661313",
      "custom_449a881a-5dd4-410e-8758-7e63c1e35606",
      "custom_1cb0d3d7-52d0-4e94-8c0f-c9981a6b6ed0",
      "custom_600c4088-3afe-4694-b981-41e36e7b7f50",
      "custom_6c529cf2-d601-4163-a074-fe11e628bcda",
      "custom_7298cfa7-cb27-4d39-868a-5a44d0a9dafd",
      "custom_51eba66c-cbe4-4c92-a610-b0afd0ca86d8",
      "custom_14282197-8a02-406b-8627-dfe4e46eeda0",
      "custom_9ccd933e-047f-4e8f-9226-a85b5c16e8a2",
      "custom_16f4f095-912c-484b-ab39-8a5d7ddaa9e3",
      "custom_db540e51-08c9-4dbb-85b9-67e4e3aa13bb",
      "custom_57a46528-281b-4336-a156-7ce6cf5b3705",
      "custom_0ac6f99e-f73e-464a-a57b-a978728baea3",
      "custom_524d12a7-ae80-4c7c-8d51-4a3e8dc4c64d",
      "custom_2232c1d8-84db-494c-8112-c1db54686e7c",
      "custom_fdea397d-7530-4f7c-935c-fe2e2d009baf",
      "custom_a6cbe333-6c93-4f93-bb1c-76a4e8e0cd67",
      "custom_fcb78d4a-3044-4d2f-956a-4d043d78813d",
      "custom_eac708ff-06c4-46cb-b43c-573f2e2b2fcd",
      "custom_6d8378e4-7e08-44c9-a168-4c3539e36a88",
      "custom_2aea9ff4-f0fc-47a8-9909-317549012f5a",
      "custom_ce2ab245-426b-40a3-beb3-91ee0352e184",
      "custom_9355359b-1af5-405c-aab6-64cb9fd87909",
      "custom_a9f21928-25e9-457f-b4eb-b48af142f428",
      "custom_2e1a8b47-33e2-4fd4-b618-a1ef1d53460b",
      "custom_68889ba5-afe4-4010-84a7-7d2625975276",
      "custom_bd968bdf-72e2-46fc-a3bc-c94e82a6f8cf",
      "custom_31ad83ac-8ea2-438f-839b-42e319e57647",
      "custom_a05491ca-37e6-431d-878f-29277890f150",
      "custom_fd6c628e-a141-422f-b290-b87948894a8b",
      "custom_1f7eb865-9af3-4318-9427-8c496220ef65",
      "custom_c8536267-5a38-46df-9b16-b5aa87a2d69b",
      "custom_5f1323fa-bb9f-4cce-8b5e-a390df5193f3",
      "custom_9087fe08-b3bb-4e83-840f-acea58ad99d8",
      "custom_b28eabe2-54d1-4ac8-9627-6cc5630983b4",
      "custom_2fe0976f-bc79-4ed6-80f4-24e068e9d285",
      "custom_4f396ac2-5fd4-4e3a-8ff3-60652dcec6d3",
      "custom_d1c904c4-04ff-443d-a61d-af1fba337bc0",
      "custom_b4a20275-dfa0-4bf7-97c5-2f77d44754df",
      "custom_3cdcca2d-5820-4836-9adf-30c1394bc2e0",
      "custom_1bb106d8-a7ae-4871-b714-5975a322ce32",
      "custom_4b07b9b4-cc92-4dd0-adbf-902d6c801bd9",
      "custom_085f86e1-f232-4de2-8e78-3755c3e4f7a2",
      "custom_a6984164-88c7-4560-81f2-5c65a41475f8",
      "custom_4c7a66c8-6775-4ae5-b7e1-c73b7ac1f938",
      "custom_15213f11-f706-4a79-9478-d67b530690c1",
      "custom_80236db5-e4b8-4a3d-a9c5-0a2983fc03c7",
      "custom_93ccf5bb-433b-4264-aaa9-80def1f17a99",
      "custom_94155b7c-f648-4ebe-842e-d43114ce4a4b",
      "custom_a7146f85-55e6-43c8-a126-d82410ca0e02",
      "custom_21ce6044-7a7c-41a8-b7a0-9508001c9e5f",
      "custom_de6717d5-2f17-4501-a00e-901ec8989b05",
      "custom_9fbb8626-c811-4032-9b15-3f18aa09c83d",
      "custom_5ac70284-430f-4909-bf53-0c91a7214969",
      "custom_e128200c-47a2-471c-954a-66185b6cb4dd",
      "custom_e0ca08a0-6bd7-41fd-81b0-03a29a4d2e7b",
      "custom_d3165e95-8afd-43a2-97db-b0bf094a10af",
      "custom_fdca9f81-a929-42c4-823d-48dcff4abc75",
      "custom_a0fa0716-6a1f-4203-9f43-3737866ef548",
      "custom_966bcea6-0c60-418b-adde-564f74fc9a8a",
      "custom_b684d900-3aec-433c-92cd-1b3971ff8646",
      "custom_0d8b3557-0a2c-419f-9646-d9106a646879",
      "custom_5aa01b6c-4a24-42f0-a106-5f47030fff0f",
      "custom_03996cd7-80cd-47b9-82a5-b8fee05f3530",
      "custom_1e7ac4f2-471e-46ce-bd7d-d14835394135",
      "custom_ba6b9016-fd5a-4e78-bcc1-4731fddf15b2",
      "custom_aa1a64f2-08fc-42be-8de6-8afd630f371b",
      "custom_5ef3dd86-5ecf-4cf8-b200-eff36a21a391",
      "custom_5f18451f-8a40-4076-a722-e5c9c2326edf",
      "custom_f9e4f50a-80a9-4f6f-a7c3-3dce85c24174",
      "custom_4ebe5d75-1164-4405-b0c1-b78d379fdc3d",
      "custom_15461f07-cc9f-4061-9309-59281a84fcd3",
      "custom_998a01ed-e058-4e55-a6d4-3db629054e5b",
      "custom_af0de621-2757-4d4d-9d3b-648e63c5caa4",
      "custom_49fda75f-865a-4f66-8444-0b0208fb9f3c",
      "custom_8d5735ea-c4c2-4347-95a9-391f5d63fb0b",
      "custom_6fdf1c1f-4400-4abe-bffe-806c87b2cff0",
      "custom_4969ded5-0bcb-4a5a-ba25-3fbc0c405c7b",
      "custom_b51929c3-5018-46cf-a1a1-edbad60c1e5c",
      "custom_fe91547e-3d50-40bb-aa3c-95bde4d166cc",
      "custom_a8576a42-5ea3-4a4f-a3b4-96846a4e6737",
      "custom_535d1fab-ba80-4f64-a1b3-8be841a7ae8c"
    ],
    "hiddenIndices": [
      14,
      0,
      2,
      3,
      16,
      17,
      18,
      21,
      24,
      25,
      50,
      53,
      54,
      55,
      8,
      92,
      13,
      20,
      11,
      5,
      1,
      9,
      7,
      6
    ],
    "ordering": [
      4,
      15,
      13,
      20,
      11,
      5,
      1,
      9,
      12,
      52,
      7,
      26,
      42,
      8,
      29,
      10,
      93,
      57,
      2,
      3,
      6,
      0,
      14,
      16,
      17,
      18,
      19,
      21,
      22,
      23,
      24,
      25,
      27,
      28,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      53,
      54,
      55,
      56,
      58,
      59,
      60,
      61,
      62,
      63,
      64,
      65,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      75,
      76,
      77,
      78,
      79,
      80,
      81,
      82,
      83,
      84,
      85,
      86,
      87,
      88,
      89,
      90,
      91,
      92,
      94,
      95,
      96,
      97,
      98,
      99,
      100,
      101,
      102,
      103,
      104,
      105,
      106,
      107,
      108,
      109,
      110,
      111,
      112,
      113,
      114,
      115,
      116
    ],
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "callrail-tracking",
      "blockId": "callrail-tracking",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 9,
      "gridSpanMobile": 12
    }
  ],
  "schedule-a-tour": [
    {
      "sectionId": "elise-schedule-tour-iframe",
      "blockId": "elise-schedule-tour-iframe",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.block:iframe-embed": {
    "properties": {
      "overflow": "hidden"
    }
  },
  "neighborhoodcallout.image_2": {
    "properties": {
      "fontSize": "1px"
    }
  }
};
